module.exports = "<!-- -MEDIA CONTENT HTML HERE- -->\r\n<div class=\"content\" style=\"overflow:hidden;\">\r\n\t<!-- -FOR IMAGE ONLY- -->\r\n\t<img [src]=\"currentMediaInformation?.media_url\" *ngIf=\"currentMediaInformation?.media_type == 'IMAGE'\" />\r\n\t\r\n\t<!-- -FOR VIDEO ONLY- -->\r\n\t<video style=\"width:100%;\" #campaignVideoPlayer></video>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/shared/components/demo-preview-on-region/demo-preview-on-region.html
// module id = 1565
// module chunks = 18